var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { ControlLabel, FormGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Radio from './Radio';
import React from 'react';
import Text from './Text';

import './RadioList.css';

function RadioList(_ref, _ref2) {
  var label = _ref.label,
      name = _ref.name,
      options = _ref.options;
  var form = _ref2.form;

  var className = label ? 'LabeledRadioList' : null;

  options = options.map(function (option, i) {
    var button = React.createElement(Radio, _extends({ key: i, name: name }, option));
    var checked = form.get(name) === option.value;

    if (option.text && checked) {
      return React.createElement(
        'div',
        { className: 'radio', key: i },
        button,
        React.createElement(Text, option.text)
      );
    }

    return button;
  });

  return React.createElement(
    'div',
    { className: className },
    label && React.createElement(
      ControlLabel,
      null,
      label
    ),
    React.createElement(
      FormGroup,
      null,
      options
    )
  );
}

RadioList.contextTypes = {
  form: PropTypes.object.isRequired
};

RadioList.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    text: PropTypes.shape({
      name: PropTypes.string.isRequired,
      placeholder: PropTypes.string.isRequired
    }),
    value: PropTypes.string.isRequired
  })).isRequired
} : {};

export default RadioList;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/RadioList.js
// module id = 711
// module chunks = 0